var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var _excluded = ["isClean", "isCache", "isStale", "parseResponseOnError"];
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var we = Object.defineProperty;
var be = function be(t, o, i) {
  return o in t ? we(t, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: i
  }) : t[o] = i;
};
var ne = function ne(t, o, i) {
  return be(t, typeof o != "symbol" ? o + "" : o, i);
};
import { useReducer as _e, useRef as H, useMemo as K, useCallback as $, useEffect as q, useState as Y } from "react";
import { styled as x, css as T } from "styled-components";
var fe = {
    error: void 0,
    response: void 0,
    isLoading: !1,
    state: "idle"
  },
  Ae = function Ae(t, o) {
    var i;
    switch (o.type) {
      case "loading":
        return _objectSpread(_objectSpread({}, t), {}, {
          response: (i = o.meta) != null && i.isStale ? t.response : void 0,
          error: void 0,
          isLoading: !0,
          state: "loading"
        });
      case "fetched":
        return _objectSpread(_objectSpread({}, t), {}, {
          response: o.payload,
          isLoading: !1,
          state: "success"
        });
      case "error":
        return _objectSpread(_objectSpread({}, t), {}, {
          error: o.payload,
          isLoading: !1,
          state: "error"
        });
      case "reset":
        return fe;
      default:
        return t;
    }
  },
  Pe = {
    isClean: !0,
    isCache: !0,
    isStale: !1,
    parseResponseOnError: !1,
    headers: {
      "Content-type": "application/json;charset=UTF-8"
    }
  },
  Oe = function Oe(t) {
    var o = de(t),
      _e2 = _e(Ae, fe),
      _e3 = _slicedToArray(_e2, 2),
      i = _e3[0],
      s = _e3[1],
      d = H({}),
      p = H(null),
      f = K(function () {
        return window.AbortController ? new window.AbortController() : void 0;
      }, []),
      c = $( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var j,
          _len,
          O,
          _key,
          b,
          S,
          C,
          P,
          L,
          z,
          _O$,
          R,
          G,
          I,
          v,
          D,
          k,
          M,
          _yield$import,
          _v,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (_len = _args.length, O = new Array(_len), _key = 0; _key < _len; _key++) {
                  O[_key] = _args[_key];
                }
                b = o.isClean, S = o.isCache, C = o.isStale, P = o.parseResponseOnError, L = _objectWithoutProperties(o, _excluded), z = O[0], _O$ = O[1], R = _O$ === void 0 ? {} : _O$;
                if (z) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return");
              case 4:
                p.current = O, s({
                  type: "loading",
                  meta: {
                    isStale: C
                  }
                });
                G = d.current[z];
                if (!(G && re(R))) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return", (s({
                  type: "fetched",
                  payload: G
                }), G));
              case 8:
                _context.prev = 8;
                _context.next = 11;
                return fetch(z, _objectSpread(_objectSpread(_objectSpread({}, L), R), {}, {
                  signal: f == null ? void 0 : f.signal
                }));
              case 11:
                I = _context.sent;
                if (I.ok) {
                  _context.next = 20;
                  break;
                }
                if (!P) {
                  _context.next = 19;
                  break;
                }
                _context.next = 16;
                return I.json();
              case 16:
                v = _context.sent;
                s({
                  type: "error",
                  payload: v
                });
                return _context.abrupt("return");
              case 19:
                throw new Error(I.statusText);
              case 20:
                if (!((j = f == null ? void 0 : f.signal) != null && j.aborted)) {
                  _context.next = 22;
                  break;
                }
                return _context.abrupt("return");
              case 22:
                _context.next = 24;
                return I.json();
              case 24:
                D = _context.sent;
                k = "data" in D ? D : {
                  data: D
                };
                M = k.data;
                if (!b) {
                  _context.next = 33;
                  break;
                }
                _context.next = 30;
                return import("./decodeData-CKRLsI2r.js");
              case 30:
                _yield$import = _context.sent;
                _v = _yield$import.decodeData;
                M = _v(k.data);
              case 33:
                return _context.abrupt("return", (S && re(R) && (d.current[z] = M), s({
                  type: "fetched",
                  payload: M
                }), M));
              case 36:
                _context.prev = 36;
                _context.t0 = _context["catch"](8);
                if (!Ee(_context.t0)) {
                  _context.next = 40;
                  break;
                }
                return _context.abrupt("return");
              case 40:
                s({
                  type: "error",
                  payload: _context.t0
                });
              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 36]]);
      })), [f == null ? void 0 : f.signal, o]),
      g = $(function () {
        return s({
          type: "reset"
        });
      }, []),
      m = $(function (O) {
        if (!p.current) return console.warn("useFetch: fetch state wasn't initialized, make fetch before revalidate"), Promise.resolve();
        var _p$current = _slicedToArray(p.current, 2),
          b = _p$current[0],
          _p$current$ = _p$current[1],
          S = _p$current$ === void 0 ? {} : _p$current$;
        return d.current[b] = void 0, c(b, _objectSpread(_objectSpread({}, S), O));
      }, [c, p]),
      h = K(function () {
        return _objectSpread(_objectSpread({}, i), {}, {
          reset: g,
          revalidate: m
        });
      }, [g, m, i]);
    return q(function () {
      return function () {
        f == null || f.abort();
      };
    }, [f]), [c, h];
  };
function Be(t, o) {
  var i = de(o),
    _Oe = Oe(i),
    _Oe2 = _slicedToArray(_Oe, 2),
    s = _Oe2[0],
    d = _Oe2[1];
  return q(function () {
    t && s(t);
  }, [s, t]), d;
}
var de = function de() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _Pe$t = _objectSpread(_objectSpread({}, Pe), t),
      o = _Pe$t.isCache,
      i = _Pe$t.isClean,
      s = _Pe$t.isStale,
      d = _Pe$t.parseResponseOnError,
      p = _Pe$t.body,
      f = _Pe$t.method,
      c = _Pe$t.mode,
      g = _Pe$t.headers,
      m = _Pe$t.keepalive,
      h = _Pe$t.cache,
      O = _Pe$t.credentials,
      b = _Pe$t.window,
      S = _Pe$t.redirect,
      C = _Pe$t.integrity,
      P = _Pe$t.referrerPolicy,
      L = _Pe$t.signal;
    return K(function () {
      return {
        isCache: o,
        isClean: i,
        isStale: s,
        parseResponseOnError: d,
        body: p,
        method: f,
        mode: c,
        headers: g,
        keepalive: m,
        cache: h,
        credentials: O,
        window: b,
        redirect: S,
        integrity: C,
        referrerPolicy: P,
        signal: L
      };
    }, [p, h, O, g, C, o, i, s, m, f, c, d, S, P, L, b]);
  },
  Ee = function Ee(t) {
    var o = t;
    return (o == null ? void 0 : o.name) === "AbortError";
  },
  re = function re(t) {
    return !t.method || t.method.toLocaleUpperCase() === "GET";
  },
  Se = x.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"])));
x.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
x.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"])));
x.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
x(Se)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"])));
x.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
x.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref2) {
  var t = _ref2.theme;
  return t.colors.red50;
});
T(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref3) {
  var t = _ref3.theme.down;
  return t("tablet");
});
var ge = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  pe = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  me = "0px 4px 28px rgba(0, 0, 0, 0.14)";
T(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], ge);
T(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], pe);
T(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], me);
T(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], ge);
T(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], pe);
T(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], me);
var He = function He() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    var _Y = Y(t),
      _Y2 = _slicedToArray(_Y, 2),
      o = _Y2[0],
      i = _Y2[1],
      s = $(function () {
        return i(function (d) {
          return !d;
        });
      }, [i]);
    return {
      isToggled: o,
      toggle: s
    };
  },
  Ke = function Ke(t, o) {
    q(function () {
      var i = function i(s) {
        Array.isArray(t) && t.some(function (p) {
          return !p.current || p.current.contains((s == null ? void 0 : s.target) || null);
        }) || !Array.isArray(t) && (!t.current || t.current.contains((s == null ? void 0 : s.target) || null)) || o(s);
      };
      return document.addEventListener("mousedown", i), document.addEventListener("touchstart", i), function () {
        document.removeEventListener("mousedown", i), document.removeEventListener("touchstart", i);
      };
    }, [t, o]);
  },
  Ye = function Ye() {
    var _Y3 = Y({
        width: 0,
        height: 0
      }),
      _Y4 = _slicedToArray(_Y3, 2),
      t = _Y4[0],
      o = _Y4[1];
    return q(function () {
      var i = function i() {
        o({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };
      return i(), window.addEventListener("resize", i), function () {
        window.removeEventListener("resize", i);
      };
    }, []), t;
  },
  ae = function ae(t, o, i) {
    if (!Object.prototype.hasOwnProperty.call(t, o)) return null;
    var s = t[o];
    if (typeof s != "boolean" && !s) return null;
    if (Array.isArray(s)) {
      var p = [];
      return s.forEach(function (f) {
        p.push("".concat(o, "[]=").concat(f));
      }), p.join("&");
    }
    return "".concat(i ? i(o) : o, "=").concat(s);
  },
  Ze = function Ze(t) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i = o.pathParams,
      s = o.query,
      d = o.filterQuery,
      p = [];
    return i && Object.entries(i).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        f = _ref5[0],
        c = _ref5[1];
      if (c === void 0) {
        t = t.replace(new RegExp("/:".concat(f, "\\??")), "");
        return;
      }
      t = t.replace(new RegExp(":".concat(f, "\\??")), String(c));
    }), s && Object.keys(s).forEach(function (f) {
      var c = ae(s, f);
      c && p.push(c);
    }), d && Object.keys(d).forEach(function (f) {
      var c = ae(d, f, function (g) {
        return "filter[".concat(g, "]");
      });
      c && p.push(c);
    }), p.length && (t += "?".concat(p.join("&"))), t;
  },
  Je = function Je(t) {
    return t === "Clever District" || t === "Clever Library" ? "Clever" : t === "ClassLink District" ? "ClassLink" : "Manual";
  },
  Ie = 300;
function Xe(t) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Ie;
  var i;
  return function () {
    for (var _len2 = arguments.length, s = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      s[_key2] = arguments[_key2];
    }
    clearTimeout(i), i = setTimeout(function () {
      t(s);
    }, o);
  };
}
var Ce = function Ce(t) {
    return crypto.getRandomValues(new Uint8Array(t));
  },
  Ge = function Ge(t, o, i) {
    var s = (2 << Math.log(t.length - 1) / Math.LN2) - 1,
      d = -~(1.6 * s * o / t.length);
    return function () {
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : o;
      var f = "";
      for (;;) {
        var c = i(d),
          g = d;
        for (; g--;) {
          if (f += t[c[g] & s] || "", f.length === p) return f;
        }
      }
    };
  },
  xe = function xe(t) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 21;
    return Ge(t, o, Ce);
  };
var Te = xe("1234567890abcdef", 14),
  he = function he(t) {
    if (!t) throw new Error("Application name is required");
    return "".concat(t, "-").concat(Te());
  },
  Ne = function Ne() {
    return he(Z.e4);
  },
  et = function et() {
    return he(Z.seasons);
  };
var Z = /* @__PURE__ */function (t) {
    return t.e4 = "elements", t.seasons = "ke", t;
  }(Z || {}),
  F = {},
  Q = {},
  V = {},
  ie;
function Le() {
  return ie || (ie = 1, function (t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = function o() {
        for (var d = arguments.length, p = new Array(d), f = 0; f < d; f++) {
          p[f] = arguments[f];
        }
        if (typeof window < "u") {
          var c;
          typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function () {
            window.dataLayer.push(arguments);
          }), (c = window).gtag.apply(c, p);
        }
      },
      i = o;
    t.default = i;
  }(V)), V;
}
var B = {},
  oe;
function ze() {
  return oe || (oe = 1, function (t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = f;
    var o = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
    function i(c) {
      return c.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (g, m, h) {
        return m > 0 && m + g.length !== h.length && g.search(o) > -1 && h.charAt(m - 2) !== ":" && (h.charAt(m + g.length) !== "-" || h.charAt(m - 1) === "-") && h.charAt(m - 1).search(/[^\s-]/) < 0 ? g.toLowerCase() : g.substr(1).search(/[A-Z]|\../) > -1 ? g : g.charAt(0).toUpperCase() + g.substr(1);
      });
    }
    function s(c) {
      return typeof c == "string" && c.indexOf("@") !== -1;
    }
    var d = "REDACTED (Potential Email Address)";
    function p(c) {
      return s(c) ? (console.warn("This arg looks like an email address, redacting."), d) : c;
    }
    function f() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "",
        g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
        m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0,
        h = c || "";
      return g && (h = i(c)), m && (h = p(h)), h;
    }
  }(B)), B;
}
var se;
function Re() {
  return se || (se = 1, function (t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.GA4 = void 0;
    var o = f(Le()),
      i = f(ze()),
      s = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"],
      d = ["title", "location"],
      p = ["page", "hitType"];
    function f(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function c(a, e) {
      if (a == null) return {};
      var n = g(a, e),
        r,
        u;
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(a);
        for (u = 0; u < l.length; u++) {
          r = l[u], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(a, r) && (n[r] = a[r]);
        }
      }
      return n;
    }
    function g(a, e) {
      if (a == null) return {};
      var n = {},
        r = Object.keys(a),
        u,
        l;
      for (l = 0; l < r.length; l++) {
        u = r[l], !(e.indexOf(u) >= 0) && (n[u] = a[u]);
      }
      return n;
    }
    function m(a) {
      "@babel/helpers - typeof";

      return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (e) {
        return typeof e;
      } : function (e) {
        return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, m(a);
    }
    function h(a) {
      return S(a) || b(a) || R(a) || O();
    }
    function O() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function b(a) {
      if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
    }
    function S(a) {
      if (Array.isArray(a)) return G(a);
    }
    function C(a, e) {
      var n = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(a);
        e && (r = r.filter(function (u) {
          return Object.getOwnPropertyDescriptor(a, u).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function P(a) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e] != null ? arguments[e] : {};
        e % 2 ? C(Object(n), !0).forEach(function (r) {
          v(a, r, n[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(n)) : C(Object(n)).forEach(function (r) {
          Object.defineProperty(a, r, Object.getOwnPropertyDescriptor(n, r));
        });
      }
      return a;
    }
    function L(a, e) {
      return I(a) || j(a, e) || R(a, e) || z();
    }
    function z() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function R(a, e) {
      if (a) {
        if (typeof a == "string") return G(a, e);
        var n = Object.prototype.toString.call(a).slice(8, -1);
        if (n === "Object" && a.constructor && (n = a.constructor.name), n === "Map" || n === "Set") return Array.from(a);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return G(a, e);
      }
    }
    function G(a, e) {
      (e == null || e > a.length) && (e = a.length);
      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = a[n];
      }
      return r;
    }
    function j(a, e) {
      var n = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
      if (n != null) {
        var r,
          u,
          l,
          y,
          w = [],
          _ = !0,
          A = !1;
        try {
          if (l = (n = n.call(a)).next, e !== 0) for (; !(_ = (r = l.call(n)).done) && (w.push(r.value), w.length !== e); _ = !0) {
            ;
          }
        } catch (E) {
          A = !0, u = E;
        } finally {
          try {
            if (!_ && n.return != null && (y = n.return(), Object(y) !== y)) return;
          } finally {
            if (A) throw u;
          }
        }
        return w;
      }
    }
    function I(a) {
      if (Array.isArray(a)) return a;
    }
    function D(a, e) {
      if (!(a instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function k(a, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(a, J(r.key), r);
      }
    }
    function M(a, e, n) {
      return e && k(a.prototype, e), Object.defineProperty(a, "prototype", {
        writable: !1
      }), a;
    }
    function v(a, e, n) {
      return e = J(e), e in a ? Object.defineProperty(a, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : a[e] = n, a;
    }
    function J(a) {
      var e = ye(a, "string");
      return m(e) === "symbol" ? e : String(e);
    }
    function ye(a, e) {
      if (m(a) !== "object" || a === null) return a;
      var n = a[Symbol.toPrimitive];
      if (n !== void 0) {
        var r = n.call(a, e || "default");
        if (m(r) !== "object") return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (e === "string" ? String : Number)(a);
    }
    var X = /* @__PURE__ */function () {
      function a() {
        var e = this;
        D(this, a), v(this, "reset", function () {
          e.isInitialized = !1, e._testMode = !1, e._currentMeasurementId, e._hasLoadedGA = !1, e._isQueuing = !1, e._queueGtag = [];
        }), v(this, "_gtag", function () {
          for (var n = arguments.length, r = new Array(n), u = 0; u < n; u++) {
            r[u] = arguments[u];
          }
          e._testMode || e._isQueuing ? e._queueGtag.push(r) : o.default.apply(void 0, r);
        }), v(this, "_loadGA", function (n, r) {
          var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
          if (!(typeof window > "u" || typeof document > "u") && !e._hasLoadedGA) {
            var l = document.createElement("script");
            l.async = !0, l.src = "".concat(u, "?id=").concat(n), r && l.setAttribute("nonce", r), document.body.appendChild(l), window.dataLayer = window.dataLayer || [], window.gtag = function () {
              window.dataLayer.push(arguments);
            }, e._hasLoadedGA = !0;
          }
        }), v(this, "_toGtagOptions", function (n) {
          if (n) {
            var r = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
              },
              u = Object.entries(n).reduce(function (l, y) {
                var w = L(y, 2),
                  _ = w[0],
                  A = w[1];
                return r[_] ? l[r[_]] = A : l[_] = A, l;
              }, {});
            return u;
          }
        }), v(this, "initialize", function (n) {
          var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if (!n) throw new Error("Require GA_MEASUREMENT_ID");
          var u = typeof n == "string" ? [{
            trackingId: n
          }] : n;
          e._currentMeasurementId = u[0].trackingId;
          var l = r.gaOptions,
            y = r.gtagOptions,
            w = r.nonce,
            _ = r.testMode,
            A = _ === void 0 ? !1 : _,
            E = r.gtagUrl;
          if (e._testMode = A, A || e._loadGA(e._currentMeasurementId, w, E), e.isInitialized || (e._gtag("js", /* @__PURE__ */new Date()), u.forEach(function (U) {
            var te = P(P(P({}, e._toGtagOptions(P(P({}, l), U.gaOptions))), y), U.gtagOptions);
            Object.keys(te).length ? e._gtag("config", U.trackingId, te) : e._gtag("config", U.trackingId);
          })), e.isInitialized = !0, !A) {
            var N = h(e._queueGtag);
            for (e._queueGtag = [], e._isQueuing = !1; N.length;) {
              var ee = N.shift();
              e._gtag.apply(e, h(ee)), ee[0] === "get" && (e._isQueuing = !0);
            }
          }
        }), v(this, "set", function (n) {
          if (!n) {
            console.warn("`fieldsObject` is required in .set()");
            return;
          }
          if (m(n) !== "object") {
            console.warn("Expected `fieldsObject` arg to be an Object");
            return;
          }
          Object.keys(n).length === 0 && console.warn("empty `fieldsObject` given to .set()"), e._gaCommand("set", n);
        }), v(this, "_gaCommandSendEvent", function (n, r, u, l, y) {
          e._gtag("event", r, P(P({
            event_category: n,
            event_label: u,
            value: l
          }, y && {
            non_interaction: y.nonInteraction
          }), e._toGtagOptions(y)));
        }), v(this, "_gaCommandSendEventParameters", function () {
          for (var n = arguments.length, r = new Array(n), u = 0; u < n; u++) {
            r[u] = arguments[u];
          }
          if (typeof r[0] == "string") e._gaCommandSendEvent.apply(e, h(r.slice(1)));else {
            var l = r[0],
              y = l.eventCategory,
              w = l.eventAction,
              _ = l.eventLabel,
              A = l.eventValue;
            l.hitType;
            var E = c(l, s);
            e._gaCommandSendEvent(y, w, _, A, E);
          }
        }), v(this, "_gaCommandSendTiming", function (n, r, u, l) {
          e._gtag("event", "timing_complete", {
            name: r,
            value: u,
            event_category: n,
            event_label: l
          });
        }), v(this, "_gaCommandSendPageview", function (n, r) {
          if (r && Object.keys(r).length) {
            var u = e._toGtagOptions(r),
              l = u.title,
              y = u.location,
              w = c(u, d);
            e._gtag("event", "page_view", P(P(P(P({}, n && {
              page_path: n
            }), l && {
              page_title: l
            }), y && {
              page_location: y
            }), w));
          } else n ? e._gtag("event", "page_view", {
            page_path: n
          }) : e._gtag("event", "page_view");
        }), v(this, "_gaCommandSendPageviewParameters", function () {
          for (var n = arguments.length, r = new Array(n), u = 0; u < n; u++) {
            r[u] = arguments[u];
          }
          if (typeof r[0] == "string") e._gaCommandSendPageview.apply(e, h(r.slice(1)));else {
            var l = r[0],
              y = l.page;
            l.hitType;
            var w = c(l, p);
            e._gaCommandSendPageview(y, w);
          }
        }), v(this, "_gaCommandSend", function () {
          for (var n = arguments.length, r = new Array(n), u = 0; u < n; u++) {
            r[u] = arguments[u];
          }
          var l = typeof r[0] == "string" ? r[0] : r[0].hitType;
          switch (l) {
            case "event":
              e._gaCommandSendEventParameters.apply(e, r);
              break;
            case "pageview":
              e._gaCommandSendPageviewParameters.apply(e, r);
              break;
            case "timing":
              e._gaCommandSendTiming.apply(e, h(r.slice(1)));
              break;
            case "screenview":
            case "transaction":
            case "item":
            case "social":
            case "exception":
              console.warn("Unsupported send command: ".concat(l));
              break;
            default:
              console.warn("Send command doesn't exist: ".concat(l));
          }
        }), v(this, "_gaCommandSet", function () {
          for (var n = arguments.length, r = new Array(n), u = 0; u < n; u++) {
            r[u] = arguments[u];
          }
          typeof r[0] == "string" && (r[0] = v({}, r[0], r[1])), e._gtag("set", e._toGtagOptions(r[0]));
        }), v(this, "_gaCommand", function (n) {
          for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), l = 1; l < r; l++) {
            u[l - 1] = arguments[l];
          }
          switch (n) {
            case "send":
              e._gaCommandSend.apply(e, u);
              break;
            case "set":
              e._gaCommandSet.apply(e, u);
              break;
            default:
              console.warn("Command doesn't exist: ".concat(n));
          }
        }), v(this, "ga", function () {
          for (var n = arguments.length, r = new Array(n), u = 0; u < n; u++) {
            r[u] = arguments[u];
          }
          if (typeof r[0] == "string") e._gaCommand.apply(e, r);else {
            var l = r[0];
            e._gtag("get", e._currentMeasurementId, "client_id", function (y) {
              e._isQueuing = !1;
              var w = e._queueGtag;
              for (l({
                get: function get(E) {
                  return E === "clientId" ? y : E === "trackingId" ? e._currentMeasurementId : E === "apiVersion" ? "1" : void 0;
                }
              }); w.length;) {
                var _ = w.shift();
                e._gtag.apply(e, h(_));
              }
            }), e._isQueuing = !0;
          }
          return e.ga;
        }), v(this, "event", function (n, r) {
          if (typeof n == "string") e._gtag("event", n, e._toGtagOptions(r));else {
            var u = n.action,
              l = n.category,
              y = n.label,
              w = n.value,
              _ = n.nonInteraction,
              A = n.transport;
            if (!l || !u) {
              console.warn("args.category AND args.action are required in event()");
              return;
            }
            var E = {
              hitType: "event",
              eventCategory: (0, i.default)(l),
              eventAction: (0, i.default)(u)
            };
            y && (E.eventLabel = (0, i.default)(y)), typeof w < "u" && (typeof w != "number" ? console.warn("Expected `args.value` arg to be a Number.") : E.eventValue = w), typeof _ < "u" && (typeof _ != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : E.nonInteraction = _), typeof A < "u" && (typeof A != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(A) === -1 && console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"), E.transport = A)), e._gaCommand("send", E);
          }
        }), v(this, "send", function (n) {
          e._gaCommand("send", n);
        }), this.reset();
      }
      return M(a, [{
        key: "gtag",
        value: function value() {
          this._gtag.apply(this, arguments);
        }
      }]), a;
    }();
    t.GA4 = X;
    var ve = new X();
    t.default = ve;
  }(Q)), Q;
}
var ue;
function Me() {
  return ue || (ue = 1, function (t) {
    function o(c) {
      "@babel/helpers - typeof";

      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (g) {
        return typeof g;
      } : function (g) {
        return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
      }, o(c);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.ReactGAImplementation = void 0;
    var i = d(Re());
    function s(c) {
      if (typeof WeakMap != "function") return null;
      var g = /* @__PURE__ */new WeakMap(),
        m = /* @__PURE__ */new WeakMap();
      return (s = function s(O) {
        return O ? m : g;
      })(c);
    }
    function d(c, g) {
      if (c && c.__esModule) return c;
      if (c === null || o(c) !== "object" && typeof c != "function") return {
        default: c
      };
      var m = s(g);
      if (m && m.has(c)) return m.get(c);
      var h = {},
        O = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var b in c) {
        if (b !== "default" && Object.prototype.hasOwnProperty.call(c, b)) {
          var S = O ? Object.getOwnPropertyDescriptor(c, b) : null;
          S && (S.get || S.set) ? Object.defineProperty(h, b, S) : h[b] = c[b];
        }
      }
      return h.default = c, m && m.set(c, h), h;
    }
    var p = i.GA4;
    t.ReactGAImplementation = p;
    var f = i.default;
    t.default = f;
  }(F)), F;
}
var qe = Me();
var De = function De(_ref6) {
    var t = _ref6.id,
      o = _ref6.type,
      i = _ref6.language,
      s = _ref6.fullName,
      d = _ref6.groupId,
      p = _ref6.gaUserId,
      f = _ref6.teacherId,
      c = _ref6.email,
      g = _ref6.emailDomain,
      m = _ref6.gradeShortName,
      h = _ref6.ownerInitials,
      O = _ref6.superuserPretendMode,
      b = _ref6.accountType;
    return {
      type: o,
      id: t,
      clientId: je(),
      fullName: s,
      groupId: d,
      gaUserId: p,
      teacherId: f,
      pretendMode: O,
      language: i,
      emailDomain: g,
      gradeShortName: m,
      ownerInitials: h,
      email: c,
      accountType: b
    };
  },
  ce = function ce(t) {
    var i = {
      gaOptions: {}
    };
    for (var _len3 = arguments.length, o = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      o[_key3 - 1] = arguments[_key3];
    }
    return o.forEach(function (s) {
      i = _objectSpread(_objectSpread(_objectSpread({}, i), s), {}, {
        gaOptions: _objectSpread(_objectSpread(_objectSpread({}, i == null ? void 0 : i.gaOptions), s == null ? void 0 : s.gaOptions), {}, {
          userId: t == null ? void 0 : t.gaUserId
        })
      });
    }), i;
  },
  je = function je() {
    var t;
    return (t = document.cookie.split(";").find(function (o) {
      return o.trim().startsWith("_ga=");
    })) == null ? void 0 : t.split("=")[1].substring(6);
  },
  ke = function ke(t) {
    return {
      gaOptions: {
        user_properties: {
          cd1: t.gaUserId,
          cd9: t.clientId,
          cd11: t.accountType
        }
      }
    };
  },
  Ue = "";
var We = /*#__PURE__*/function (_qe$ReactGAImplementa) {
  _inherits(We, _qe$ReactGAImplementa);
  var _super = _createSuper(We);
  function We() {
    var _this;
    _classCallCheck(this, We);
    _this = _super.apply(this, arguments);
    ne(_assertThisInitialized(_this), "config");
    return _this;
  }
  _createClass(We, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(i, s) {
        var d, p, f, c;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (i) {
                  _context2.next = 2;
                  break;
                }
                throw new Error("Require GA_MEASUREMENT_ID");
              case 2:
                _context2.next = 4;
                return fetch("".concat(Ue, "/api/auth"));
              case 4:
                d = _context2.sent;
                if (d.ok) {
                  _context2.next = 7;
                  break;
                }
                return _context2.abrupt("return", !1);
              case 7:
                _context2.next = 9;
                return d.json();
              case 9:
                p = _context2.sent;
                if (!(this.config = De(p), this.isPretendMode)) {
                  _context2.next = 12;
                  break;
                }
                return _context2.abrupt("return", (console.debug("GA is disabled due to pretend mode."), !1));
              case 12:
                c = ke(this.config);
                return _context2.abrupt("return", (typeof s == "object" ? f = ce(this.config, c, s) : f = ce(this.config, c, s == null ? void 0 : s(this.config)), this.initialize(i, f), this.isInitialized || console.error("GA initialized with an error"), this.isInitialized));
              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "isInit",
    get: function get() {
      return this.isInitialized;
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(i, s) {
      (typeof i == "string" || $e(i)) && this.event(i, s);
    }
  }, {
    key: "setDimension",
    value: function setDimension(i) {
      var s = new Map(Object.entries(i));
      this.setDimensions(s);
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(i) {
      this.gtag("set", "user_properties", Object.fromEntries(i));
    }
  }, {
    key: "sendEventAsSupervizor",
    value: function sendEventAsSupervizor(i, s) {
      var d;
      ((d = this.config) == null ? void 0 : d.type) === "Supervizor" && this.sendEvent(i, s);
    }
  }, {
    key: "sendEventAsTeacher",
    value: function sendEventAsTeacher(i, s) {
      var d;
      ((d = this.config) == null ? void 0 : d.type) === "Teacher" && this.sendEvent(i, s);
    }
  }, {
    key: "isPretendMode",
    get: function get() {
      var i;
      return !!((i = this.config) != null && i.pretendMode);
    }
  }, {
    key: "pageView",
    value: function pageView(i) {
      this.isInit && this.send({
        hitType: "pageview",
        page: i
      });
    }
  }]);
  return We;
}(qe.ReactGAImplementation);
var le = new We();
function $e(t) {
  var o = t;
  return !!(o.action && o.category);
}
var W;
var tt = function tt(t, o) {
  var _Y5 = Y(),
    _Y6 = _slicedToArray(_Y5, 2),
    i = _Y6[0],
    s = _Y6[1],
    d = H(!0);
  if (!W && !t) throw new Error("You must provide Google analytics ID in first invocation of useGA.");
  return q(function () {
    function p() {
      return _p.apply(this, arguments);
    }
    function _p() {
      _p = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                !W && t && (W = le.init(t, o));
                _context3.next = 3;
                return W;
              case 3:
                d.current && s(le);
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _p.apply(this, arguments);
    }
    p();
  }, [t, o]), q(function () {
    return function () {
      d.current = !1;
    };
  }, []), i;
};
export { Z as ApplicationName, Ze as buildURI, Xe as debounce, Ne as getElementsErrorId, Je as getPlainRosterType, et as getSeasonsErrorId, Be as useFetch, tt as useGoogleAnalytics, Oe as useLazyFetch, Ke as useOutside, He as useToggle, Ye as useWindowSize };